import { JSX } from "react";
import { SpecialtyPredictionModelEnum } from "@app/projects/servicing-provider/provider-claims/SpecialtyPredictionModelEnum";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface SpecialtyPredictionModelFilterProps {
  selectedSpecialtyPredictionModelFilter: SpecialtyPredictionModelEnum;
  setSelectedSpecialtyPredictionModelFilter: (value: SpecialtyPredictionModelEnum) => void;
  testId: string;
}

const SpecialtyPredictionModelFilter = (props: SpecialtyPredictionModelFilterProps): JSX.Element => {
  return (
    <QESSelect
      label="Specialty Model Prediction"
      onChange={(e) => props.setSelectedSpecialtyPredictionModelFilter(e.target.value as SpecialtyPredictionModelEnum)}
      value={props.selectedSpecialtyPredictionModelFilter}
      testId={props.testId}
    >
      {Object.values(SpecialtyPredictionModelEnum).map((value, index) => (
        <option key={index} value={value}>
          {value}
        </option>
      ))}
    </QESSelect>
  );
};

export default SpecialtyPredictionModelFilter;
